import React from "react";

import { Icon, MutedDarkText } from "shared/styles";
import { CaretDown } from "shared/assets/icons";
import {
  StyledValue,
  StyledDropdownIndicator,
  StyledPrefixIcon,
} from "../styles";
import { ISelectPlaceholder } from "../types";
import { colors } from "shared/styles/constants";

export const SelectPlaceholder: React.FC<ISelectPlaceholder> = ({
  label,
  icon,
  isOpen,
}) => (
  <StyledValue>
    {icon && (
      <StyledPrefixIcon>
        <Icon size="xl" as={icon} color={colors.grey4} />
      </StyledPrefixIcon>
    )}
    <MutedDarkText>{label}</MutedDarkText>
    <StyledDropdownIndicator isOpen={isOpen}>
      <CaretDown />
    </StyledDropdownIndicator>
  </StyledValue>
);
